import { render, staticRenderFns } from "./LoFPerLanguage.vue?vue&type=template&id=124eee46&"
import script from "./LoFPerLanguage.vue?vue&type=script&lang=js&"
export * from "./LoFPerLanguage.vue?vue&type=script&lang=js&"
import style0 from "./LoFPerLanguage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports